import {
    ChangeDetectionStrategy,
    Component,
    output,
    Input,
    OnChanges,
    SimpleChanges,
    ViewEncapsulation,
    inject,
    Injector,
} from '@angular/core';
import { IChecklist2ReportChecklistSummary } from '../../../../shared/fi-checklist2-report';
import { ObjectTypes } from '@fi-shared/types';
import { isEqual } from '@fi-shared/utils';
import { FiItemsListType } from '@fi-shared/fi-items-list/fi-items-list-type';
import { FiChecklist2ReportHelperService } from '../../../../services/fi-checklist2-report-helper.service';
import { FiInfiniteScrollDataSource } from '@fi-shared/fi-items-list/fi-infinite-scroll-data-source';
import { IChecklistStatusProgressData } from '../../../../../checklist-v2';

@Component({
    selector: 'fi-open-checklists-summary-table',
    templateUrl: './open-checklists-summary-table.component.html',
    styleUrls: ['./open-checklists-summary-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'fi-open-checklists-summary-table',
        ['class.table-item-selection-prevented']: 'isTableItemSelectionPrevented',
    },
    standalone: false,
})
export class FiOpenChecklistsSummaryTableComponent
    extends FiInfiniteScrollDataSource<IChecklist2ReportChecklistSummary>
    implements OnChanges
{
    @Input() checklists: IChecklist2ReportChecklistSummary[] = [];
    @Input() isTableItemSelectionPrevented: boolean;
    public openChecklistDetails = output<IChecklist2ReportChecklistSummary>();

    protected getRowClassFn = (item: IChecklist2ReportChecklistSummary): string => {
        return this.isTableItemSelectionPrevented ? '' : 'cursor-pointer';
    };

    public readonly defaultSortColumnName: string = 'PeriodDueDateTime';
    public readonly itemsListType = FiItemsListType.ChecklistReportOpenChecklistsTable;
    public readonly defaultSortDirection: boolean = false;
    public readonly objectType: ObjectTypes = ObjectTypes.Checklist2;

    private fiChecklist2ReportHelperService = inject(FiChecklist2ReportHelperService);

    constructor(injector: Injector) {
        super(injector);
    }

    public ngOnChanges(changes: SimpleChanges): void {
        const change = changes.checklists;
        if (!!change && !isEqual(change.currentValue, change.previousValue)) {
            this.reloadData();
        }
    }

    public getListData(): Promise<IChecklist2ReportChecklistSummary[]> {
        return Promise.resolve(this.checklists);
    }

    protected getChecklistRemainingTime(endTime: string): string {
        return this.fiChecklist2ReportHelperService.getChecklistRemainingTime(endTime);
    }

    protected getChecklistStatusData(item: IChecklist2ReportChecklistSummary): IChecklistStatusProgressData {
        return {
            completedCount: item.CompletedIterationsCount,
            inProgressCount: item.InProgressIterationsCount,
            notStartedCount: item.NotStartedIterationsCount,
        };
    }
}
